import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface PopupDialogData {
  title: string;
  content: string;
}

@Component({
  selector: 'popup-dialog',
  templateUrl: 'popup-dialog.html',
})
export class PopupDialog implements OnInit {
  result:PopupDialogData;

  constructor(
    public dialogRef: MatDialogRef<PopupDialog>,
    @Inject(MAT_DIALOG_DATA) private data: PopupDialogData) {

    if (data != null) {
      this.result = data;
    }

  }

  ngOnInit() {
  }


}